import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class LandCategoriesApi extends ApiModule {
	constructor() {
		super(ModulesMap.LAND_CATEGORIES, {
			entity: 'land_categories',
		})
	}
}
